import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import Sponsor from "../../components/Sponsor/Sponsor";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const SponsorSetupPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Sponsor Setup</VolunteerHeading>
      <Sponsor />
    </MainDiv>
  );
};

export default SponsorSetupPage;
